import { useCallback } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import { HTTPIntegration } from 'libs/end-to-end/src/types/databases/integrations/http-integration';
import { HTTPIntegrationCustomHeaderListItem } from 'libs/end-to-end/src/types/databases/integrations/http-integration';
import { HTTPIntegrationURLListItem } from 'libs/end-to-end/src/types/databases/integrations/http-integration';
import { HTTP_INTEGRATION_DEFAULT_RETRY_COUNT } from 'libs/end-to-end/src/types/databases/data-sets/http-integration-defaults';
import { HTTP_INTEGRATION_DEFAULT_TIMEOUT_IN_SECONDS } from 'libs/end-to-end/src/types/databases/data-sets/http-integration-defaults';
import { Setter } from 'libs/end-to-end/src/ui-types';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';

export interface DataSetEditHTTPIntegrationHook {
  httpIntegration: HTTPIntegration;
  setHttpIntegration: Setter<HTTPIntegration>;
}

export const useDataSetEditHTTPIntegration =
  (): DataSetEditHTTPIntegrationHook => {
    const [urlList, setUrlList] = useState<HTTPIntegrationURLListItem[]>([]);
    const [timeoutInSeconds, setTimeoutInSeconds] = useState<number>(
      HTTP_INTEGRATION_DEFAULT_TIMEOUT_IN_SECONDS,
    );
    const [retryCount, setRetryCount] = useState<number>(
      HTTP_INTEGRATION_DEFAULT_RETRY_COUNT,
    );
    const [customHeaderList, setCustomHeaderList] = useState<
      HTTPIntegrationCustomHeaderListItem[]
    >([]);
    const [
      customHeaderWithSecretHeaderName,
      setCustomHeaderWithSecretHeaderName,
    ] = useState<string>('');
    const [
      customHeaderWithSecretReference,
      setCustomHeaderWithSecretReference,
    ] = useState<SecretReference | null>(null);

    const setHttpIntegration = useCallback(
      (httpIntegration: HTTPIntegration) => {
        setUrlList(httpIntegration.urlList);
        setTimeoutInSeconds(httpIntegration.timeoutInSeconds);
        setRetryCount(httpIntegration.retryCount);
        setCustomHeaderList(httpIntegration.customHeaderList);
        setCustomHeaderWithSecretHeaderName(
          httpIntegration.customHeadersWithSecrets.headerName,
        );
        setCustomHeaderWithSecretReference(
          httpIntegration.customHeadersWithSecrets.headerSecretReference ??
            null,
        );
      },
      [],
    );

    return useMemo(() => {
      return {
        httpIntegration: {
          integrationType: 'HTTP',
          urlList,
          timeoutInSeconds,
          retryCount,
          customHeaderList,
          customHeadersWithSecrets: {
            headerName: customHeaderWithSecretHeaderName,
            headerSecretReference: customHeaderWithSecretReference ?? undefined,
          },
        },
        setHttpIntegration,
      };
    }, [
      customHeaderList,
      customHeaderWithSecretHeaderName,
      customHeaderWithSecretReference,
      retryCount,
      setHttpIntegration,
      timeoutInSeconds,
      urlList,
    ]);
  };
